import { withNamespace } from '../helper';

const namespace = '@AUTHENTICATE';

export const GET_CURRENT_USER = withNamespace('GET_CURRENT_USER', namespace);
export const GET_CURRENT_USER_SUCCESS = withNamespace('GET_CURRENT_USER_SUCCESS', namespace);

export const SET_CURRENT_USER = withNamespace('SET_CURRENT_USER', namespace);
export const SET_CURRENT_USER_RESULT = withNamespace('SET_CURRENT_USER_RESULT', namespace);

export const SIGN_OUT_USER = withNamespace('SIGN_OUT_USER', namespace);
export const SIGN_OUT_USER_SUCCESS = withNamespace('SIGN_OUT_USER_SUCCESS', namespace);

export const REFRESH_TOKEN = withNamespace('REFRESH_TOKEN', namespace);
export const REFRESH_TOKEN_SUCCESS = withNamespace('REFRESH_TOKEN_SUCCESS', namespace);
export const VERIFY_TOKEN = withNamespace('VERIFY_TOKEN', namespace);
export const LOGIN = withNamespace('LOGIN', namespace);
export const LOGIN_SUCCESS = withNamespace('LOGIN_SUCCESS', namespace);
export const RESET_PASSWORD = withNamespace('RESET_PASSWORD', namespace);
export const RESET_PASSWORD_SUCCESS = withNamespace('RESET_PASSWORD_SUCCESS', namespace);
